import { lazy, Suspense } from 'react'
import { CircularProgress } from '@mui/material'

const FundingGuided = lazy(() => import('./funding-guided/FundingGuided'))

export default function FundingGuidedStep() {
  return (
    <Suspense fallback={<CircularProgress sx={{ display: 'block', mx: 'auto', mt: 8 }} />}>
      <FundingGuided />
    </Suspense>
  )
}
